/**
 * @generated SignedSource<<42ec91f684dbfaaddc5dccc42e7d6886>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PredictedEndDateModalStatsSection_project$data = {
  readonly projectEndYear: number | null;
  readonly projectEndMonth: number | null;
  readonly projectEndDay: number | null;
  readonly projectHealth: {
    readonly totalTaskEstimate: number | null;
    readonly totalBaselineEstimate: number | null;
    readonly totalTaskEstimateDone: number | null;
    readonly totalRemainingAllocation: number | null;
    readonly focus: number | null;
    readonly performanceRolling: number | null;
    readonly predictedEndDate: string | null;
    readonly optimisticPredictedEndDate: string | null;
    readonly conservativePredictedEndDate: string | null;
  } | null;
  readonly " $fragmentType": "PredictedEndDateModalStatsSection_project";
};
export type PredictedEndDateModalStatsSection_project$key = {
  readonly " $data"?: PredictedEndDateModalStatsSection_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"PredictedEndDateModalStatsSection_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PredictedEndDateModalStatsSection_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectEndYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectEndMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectEndDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectHealth",
      "kind": "LinkedField",
      "name": "projectHealth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalTaskEstimate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalBaselineEstimate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalTaskEstimateDone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalRemainingAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "focus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "performanceRolling",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "predictedEndDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optimisticPredictedEndDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conservativePredictedEndDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "453ef17d6fa88e4b92f6de0d4bcb2e68";

export default node;
